/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface AllShipmentsLaneAnalytics
 */
export interface AllShipmentsLaneAnalytics {
  /**
   *
   * @type {string}
   * @memberof AllShipmentsLaneAnalytics
   */
  lane: string;
  /**
   *
   * @type {string}
   * @memberof AllShipmentsLaneAnalytics
   */
  pickupCityState: string;
  /**
   *
   * @type {string}
   * @memberof AllShipmentsLaneAnalytics
   */
  deliveryCityState: string;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsLaneAnalytics
   */
  count: number;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsLaneAnalytics
   */
  bookedCount: number;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsLaneAnalytics
   */
  avgPrice: number;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsLaneAnalytics
   */
  totalMoneyIn: number;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsLaneAnalytics
   */
  totalMoneyOut: number;
}

/**
 * Check if a given object implements the AllShipmentsLaneAnalytics interface.
 */
export function instanceOfAllShipmentsLaneAnalytics(
  value: object,
): value is AllShipmentsLaneAnalytics {
  if (!("lane" in value) || value["lane"] === undefined) return false;
  if (!("pickupCityState" in value) || value["pickupCityState"] === undefined)
    return false;
  if (
    !("deliveryCityState" in value) ||
    value["deliveryCityState"] === undefined
  )
    return false;
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("bookedCount" in value) || value["bookedCount"] === undefined)
    return false;
  if (!("avgPrice" in value) || value["avgPrice"] === undefined) return false;
  if (!("totalMoneyIn" in value) || value["totalMoneyIn"] === undefined)
    return false;
  if (!("totalMoneyOut" in value) || value["totalMoneyOut"] === undefined)
    return false;
  return true;
}

export function AllShipmentsLaneAnalyticsFromJSON(
  json: any,
): AllShipmentsLaneAnalytics {
  return AllShipmentsLaneAnalyticsFromJSONTyped(json, false);
}

export function AllShipmentsLaneAnalyticsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AllShipmentsLaneAnalytics {
  if (json == null) {
    return json;
  }
  return {
    lane: json["lane"],
    pickupCityState: json["pickupCityState"],
    deliveryCityState: json["deliveryCityState"],
    count: json["count"],
    bookedCount: json["bookedCount"],
    avgPrice: json["avgPrice"],
    totalMoneyIn: json["totalMoneyIn"],
    totalMoneyOut: json["totalMoneyOut"],
  };
}

export function AllShipmentsLaneAnalyticsToJSON(
  json: any,
): AllShipmentsLaneAnalytics {
  return AllShipmentsLaneAnalyticsToJSONTyped(json, false);
}

export function AllShipmentsLaneAnalyticsToJSONTyped(
  value?: AllShipmentsLaneAnalytics | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    lane: value["lane"],
    pickupCityState: value["pickupCityState"],
    deliveryCityState: value["deliveryCityState"],
    count: value["count"],
    bookedCount: value["bookedCount"],
    avgPrice: value["avgPrice"],
    totalMoneyIn: value["totalMoneyIn"],
    totalMoneyOut: value["totalMoneyOut"],
  };
}
